<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table fixed-header height="750px" :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:header="{ props }"><table-header-filter :headers="props.headers" :viewName="viewName" v-on:applyFilter="applyFilter"></table-header-filter></template>
                    <template v-slot:item="{ item }">
                        <transaction-table-row
                            :item="item"
                            :visible-headers="headers"
                            :product-type-list="product_type_list"
                            :package-status="package_status"
                            :package-status-enum="package_status_enum"
                            :fee-type-enum="fee_type_enum"
                            :is-editable="getEditablePermission(item)"
                            :weight-editable="canEditWarehouseFields"
                            :fee-ship-editable="canEditWarehouseFields"
                            :quantity-editable="canEditWarehouseFields"
                            :can-print="warehousing"
                            :can-split="adminRoles"
                            :can-delete="getDeletePermission(item)"
                            @save-item="saveItem"
                            @goto-detail="gotoDetail"
                            @print-transaction="printTransaction"
                            @split-package="openSplitPackageDialog"
                            @delete-item="deleteItem"
                        />
                    </template>
                    <template v-slot:body.append>
                        <transaction-summary-row
                            v-if="summary"
                            :summary="summary"
                            :visible-headers="headers"
                        />
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
        <!-- <v-dialog v-model="dialogImport" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
            <v-toolbar dark color="oee-theme">
                <v-btn icon dark @click="dialogImport = false">
                <v-icon>fa-times-circle</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>{{importStep == 0 ? 'Import thông tin kiện' : 'Xác minh dữ liệu'}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex lg12 md12 sm12 xs12 pt-3 v-if="importStep == 0">
                    <a href="/package_import_template.xls">File mẫu</a>
                    <v-textarea outlined rows='30' label="Copy dữ liệu từ excel" v-model="dataImport"></v-textarea>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12 pt-3 v-else>
                    <v-data-table fixed-header height="750px"   :headers="importHeaders" :items="importItems" :items-per-page="15" class="elevation-1"></v-data-table>
                    </v-flex>
                </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1 white--text" @click="importPreview()" v-if="importStep == 0">Tiếp theo</v-btn>
                <v-btn color="blue darken-1 white--text" @click="importStep = 0" v-if="importStep == 1">Quay lại</v-btn>
                <v-btn color="red darken-1 white--text" @click="importTransaction" v-if="importStep == 1">Nhập dữ liệu</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog> -->
        <split-package
            :dialogSplitPackage="dialogSplitPackage"
            :readOnly="!adminRoles"
            :currentItem="currentItem"
            v-on:closePopup="dialogSplitPackage = false"
        ></split-package>
        <v-overlay :value="appLoading || loading" z-index="999999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <upload-file :dialogUpload="dialogImport" title="Import mã vận đơn" temp_file="package_import_template.xls" @closePopup="dialogImport=false" @importFile="importFile"></upload-file>
    </v-layout>
</v-container>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { print_transaction } from "@/commons/hpod";
import split_package from "@/components/popups/split_package";
import TransactionTableRow from "@/components/TransactionTableRow.vue";
import TransactionSummaryRow from "@/components/TransactionSummaryRow.vue";
import upload_file from "@/components/popups/upload_file";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering,
        "split-package": split_package,
        "transaction-table-row": TransactionTableRow,
        "transaction-summary-row": TransactionSummaryRow,
        "upload-file": upload_file
    },
    data() {
        return {
            dialogSplitPackage: false,
            currentItemID: 0,
            isDepositOrder: configs.SYSTEM_TYPE != 'order',
            show_quick_import_option: configs.SYSTEM_CONFIG.quick_store_import,
            package_status: configs.PACKAGE_STATUS,
            package_status_enum: configs.PACKAGE_STATUS_ENUM,
            fee_type_enum: configs.FEE_TYPE_LIST,
            pagination: {  ...configs.PAGINATION,  sortBy: ["ID"]  },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "transactioncode_list",
            filterConditions: [],
            quickFilterConditions: [],
            dialogImport: false,
            dataImport: '',      
            importUID: 0,
            importStep: 0,
            appLoading: false,
            importHeaders: [
                {
                    text: "Mã kiện",
                    value: "TransactionCode"
                },
                {
                    text: "Loại hàng",
                    value: "ProductType"
                },
                {
                    text: "K. hàng",
                    value: "Username"
                },
                {
                    text: "Ngày nhập kho TQ",
                    value: "StoreCNImportDate"
                },
                {
                    text: "Cân nặng",
                    value: "ChinaWeight"
                },
                {
                    text: "Chiều dài (cm)",
                    value: "ChinaLength"
                },
                {
                    text: "Chiều rộng (cm)",
                    value: "ChinaWidth"
                },
                {
                    text: "Chiều cao (cm)",
                    value: "ChinaHeight"
                },
                {
                    text: "Số lượng",
                    value: "RealNumberOfPack"
                },
                {
                    text: "Giá cân",
                    value: "WeightPrice"
                },
                {
                    text: "Giá khối",
                    value: "VolumePrice"
                },
                {
                    text: "Ship nội địa",
                    value: "FeeShip"
                },
                {
                    text: "Gia cố",
                    value: "FeeFragileGoods"
                },
                {
                    text: "Phí khác",
                    value: "FeeOther"
                }
            ],
            importItems: []
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        configuration: {
            handler: function (val, oldVal) {
                let header_item = _.find(this.headers, { value: "ProductType" });
                if (header_item) {
                    header_item.values = this.product_type_list;
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.orderTransaction.all.data,
            summary: state => state.orderTransaction.summary.data,
            total_rows: state => state.orderTransaction.all.total,
            loading: state => state.orderTransaction.loading,
            currentItem: state => state.orderTransaction.selected,
            customers: state => state.customer.master.data,
            configuration: state => state.configuration.selected
        }),
        // Định nghĩa tất cả headers có thể có với permissions
        allHeaders() {
            return [
                {
                    text: "Mã bill",
                    value: "TransactionCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"],
                    roles: ['all']
                },
                {
                    text: "Loại hàng",
                    value: "ProductType",
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"],
                    roles: ['all']
                },
                {
                    text: "K. hàng",
                    value: "Username",
                    quickSearch: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"],
                    roles: ['all']
                },
                {
                    text: "Mã bao",
                    value: "PackageCode",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"],
                    roles: ['all']
                },
                {
                    text: "Phiếu XK",
                    value: "ReceiptID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: "Nhập kho TQ",
                    value: "StoreCNImportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    roles: ['all']
                },
                {
                    text: "Ngày đóng bao",
                    value: "BigPackDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    roles: ['all']
                },
                {
                    text: "Xuất kho TQ",
                    value: "StoreCNExportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    roles: ['all']
                },
                {
                    text: "Nhập kho VN",
                    value: "StoreVNImportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    roles: ['all']
                },
                {
                    text: "Nhập phiếu",
                    value: "ReceiptDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    roles: ['all']
                },
                {
                    text: "Xuất kho VN",
                    value: "StoreVNExportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    roles: ['all']
                },
                {
                    text: "Phí khác",
                    value: "FeeShipVND",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: "Khối",
                    value: "Volume",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: "Số lượng",
                    value: "RealNumberOfPack",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: "Tổng cân",
                    value: "TotalWeight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: "Tổng khối",
                    value: "TotalVolume",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: "Cách tính",
                    value: "FeeType",
                    filterable: true,
                    align: "end",
                    values: this.fee_type_enum,
                    dataType: configs.DATA_TYPE["Enum"],
                    roles: ['all']
                },
                {
                    text: "Giá cân",
                    value: "WeightPrice",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: "Giá khối",
                    value: "VolumePrice",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: "Giá gốc cân",
                    value: "WeightCost",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['admin']
                },
                {
                    text: "Giá gốc khối",
                    value: "VolumeCost",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['admin']
                },
                {
                    text: "Tổng tiền",
                    value: "TotalAmount",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: "Tổng giá gốc",
                    value: "TotalCost",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['admin']
                },
                {
                    text: "Lợi nhuận",
                    value: "TotalProfit",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['admin']
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: configs.PACKAGE_STATUS,
                    roles: ['all']
                },
                {
                    text: "Ngày sửa",
                    value: "ModifiedDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    roles: ['admin']
                },
                {
                    text: "Người sửa",
                    value: "ModifiedBy",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"],
                    roles: ['admin']
                },
                {
                    text: "Ghi chú",
                    value: "StoreCNNote",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"],
                    roles: ['storeTQ']
                },
                {
                    text: "Ghi chú",
                    value: "StoreVNNote",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"],
                    roles: ['storeVN']
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false,
                    roles: ['admin', 'storeVN', 'storeTQ']
                }
            ];
        },
        currentUserRole() {
            if (this.adminRoles || this.paymentRole) return 'admin';
            if (this.storeTQRole) return 'storeTQ';
            if (this.storeVNRole) return 'storeVN';
            return 'staff';
        },
        headers() {
            // Filter headers theo role của user hiện tại
            const filteredHeaders = this.allHeaders.filter(header => {
                if (header.roles.includes('all')) return true;
                if (header.roles.includes(this.currentUserRole)) return true;
                if (this.storeVNRole && header.roles.includes('storeVN')) return true;
                if (this.storeTQRole && header.roles.includes('storeTQ')) return true;
                return false;
            });

            // Set ProductType values nếu có
            const productTypeHeader = filteredHeaders.find(h => h.value === 'ProductType');
            if (productTypeHeader) {
                productTypeHeader.values = this.product_type_list;
            }

            return filteredHeaders;
        },
        adminRoles() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager);
        },
        paymentRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment);
        },
        storeVNRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
        },
        storeTQRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
        },
        warehouseRole() {
            return this.storeVNRole || this.storeTQRole;
        },
        weightEditable() {
            return this.adminRoles || this.paymentRole || this.warehouseRole;
        },
        canEditWarehouseFields() {
            return this.adminRoles || this.paymentRole || this.warehouseRole;
        },
        warehousing() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ);
        },
        moduleRole() {
            return this.$store.state.authentication.role.Module;
        },
        filter_param() {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            return param;
        },
        product_type_list() {
            return this.configuration.ProductTypes ? JSON.parse(this.configuration.ProductTypes) : [];
        },
    },
    methods: {
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        getEditablePermission(item) {
            // Logic for editable permission based on user role and item status
            return this.adminRoles || this.paymentRole;
        },
        getDeletePermission(item) {
            // Logic for delete permission
            if (this.adminRoles) {
                return item.Status < this.package_status_enum.DA_VE_VN;
            }
            return false;
        },
        printTransaction(item) {
            print_transaction(item.Weight, item.TotalWeight, item.Length, item.Width, item.Height, 
                            item.TransactionCode, item.Username, item.OrderID, item.RealNumberOfPack);
        },
        openSplitPackageDialog(packageId) {
            this.currentItemID = packageId;
            this.$store.dispatch("orderTransaction/getDetail", packageId);
            this.dialogSplitPackage = true;
        },
        deleteItem(item) {
            window.getApp.$emit('REQUEST_DELETE_DATA', item.ID);
        },
        saveItem:_.debounce(
        function(item) {
            var data = {
                ...item
            };
            data.Type = "transaction";
            data.ModifiedBy = this.$store.state.authentication.user.username;
            if(data.Weight > 0) {
                item.Status = data.Status = configs.PACKAGE_STATUS_ENUM.DA_VE_VN;
            }
            delete data.CreatedDate;
            delete data.CreatedBy;
            this.$store.dispatch("orderTransaction/postOrderTransaction", data);
        }, 500, {leading: false, trailing: true}),
        // Only admin can view table, staff need search by code
        filter_data: function () {            
            this.$store.dispatch("orderTransaction/getList", this.filter_param);
            this.$store.dispatch("orderTransaction/getSummary", this.filter_param);
            this.getCustomerList();
            this.appLoading = false;
            if(this.currentItemID > 0) {
                this.$store.dispatch("orderTransaction/getDetail", this.currentItemID);
            }
        },
        doWarehousing(tran_code) {
            this.$store.dispatch("storeManager/setDetail", {
                data: {'TransactionCode': tran_code},
                id: 0
            });
        },
        gotoDetail: function (type, id, uid) {
            if (type) {
                let routeData = this.$router.resolve({
                    name: "DepositDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    },
                    query: {
                        'uid': uid
                    }
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: "OrderDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    }
                });
                window.open(routeData.href, "_blank");
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username", "CustomerCode"]
            });
        },
        importFile(filelist) {
            for(const f of filelist) {
                const formData = new FormData();
                formData.append('excel_file', f);
                formData.append('filename', f.name);
                this.$store.dispatch("orderTransaction/upload_import_cn_store", formData);
            }
            this.dialogImport = false;
        },
        importData() {
            this.dataImport = '';
            this.importItems = [];
            this.dialogImport = true;
        },
        importPreview(){
            this.importItems = [];
            let rows = this.dataImport.split("\n");
            if(rows.length <= 1){
                sendErrorNotice('Không tìm thấy dữ liệu import.')
                return;
            }
            let header = rows[0].split("\t");
            let props = [];
            for (let i = 0; i < header.length; i++) {
                let element = _.find(this.importHeaders, function (item) {
                    return item.text.toLowerCase() === header[i].toLowerCase();
                });
                props.push(element ? element.value : 'unknown');
            }

            if(!props.includes('TransactionCode')) {
                sendErrorNotice('Không tìm thấy dữ liệu import.')
                return;
            }
            this.importStep = 1;
            for (let i = 1; i < rows.length; i++) {
                let item = rows[i].split("\t");
                if(item.length == 0 || item[0] == '') {
                    continue;
                }
                let importItem = {};
                for (let j = 0; j < props.length; j++) {
                    let prop = props[j];
                    if(prop !== 'unknown') {
                        let val = item[j].replace(/\s+/g, ' ').trim();
                        if(val != '') {
                            importItem[prop] = val;
                        }
                    }
                }
                this.importItems.push(importItem);
            }
        },
        importTransaction() {
            this.importItems.forEach(element => {
                if(element.Username) {
                    let conf = _.find(this.customers, function (item) {
                        let ret = this.isDepositOrder ? item.CustomerCode.normalize('NFD').toLowerCase() === element.Username.normalize('NFD').toLowerCase() : item.Username.normalize('NFD').toLowerCase() === element.Username.normalize('NFD').toLowerCase();
                        return ret;
                    });
                    if(conf) {
                        element.UID = conf.ID;
                    }
                    else {
                        delete element.UID;
                    }
                }
                if(element.ProductType) {
                    let conf = _.find(this.product_type_list, function (item) {
                        let ret = item.name.normalize('NFD').toLowerCase() === element.ProductType.normalize('NFD').toLowerCase();
                        return ret;
                    });
                    if(conf) {
                        element.ProductType = conf.value;
                    }
                    else {
                        delete element.ProductType;
                    }
                }
                if(this.importUID > 0) {
                    element.UID = this.importUID;
                }
            });
            this.appLoading = true;
            this.$store.dispatch("orderTransaction/import", {'Transactions': this.importItems});
            this.dialogImport = false;
            this.importStep = 0;
            this.importUID = 0;
        },
        exportExcel() {
            this.$store.dispatch("orderTransaction/export", this.filter_param);
        },
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_CREATE_DATA", this.exportExcel);
        this.$root.$on("REQUEST_SAVE_DATA", this.importData);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("orderTransaction/removeDetail", {
                'id': id
            });
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("REQUEST_CREATE_DATA", this.exportExcel);
        this.$root.$off("REQUEST_SAVE_DATA", this.importData);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
